(function(wndw) {
  var jadify = function(jade, _t, _h) {
    var yudify = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (controlName, _t, label) {
switch (controlName){
case 'countdown':
buf.push("<div class=\"vjs-control c-countdown\"><span class=\"c-countdown-text\"><em class=\"cif-spin cif-refresh\"></em></span></div>");
  break;
case 'subtitlesMenuItem':
buf.push("<em class=\"cif-lg cif-fw c-subtitles-menu-item-selected-icon\"></em><span data-js=\"c-subtitles-menu-item-label\" class=\"c-subtitles-menu-item-label caption-text\">" + (jade.escape(null == (jade_interp = _t(label)) ? "" : jade_interp)) + "</span>");
  break;
case 'subtitlesOffLabel':
buf.push("" + (jade.escape((jade_interp = _t("Subtitles Off")) == null ? '' : jade_interp)) + "");
  break;
case 'subtitlesMenuTitle':
buf.push("<h3 class=\"vjs-menu-title headline-1-text menu-section-title\">" + (jade.escape((jade_interp = _t("Subtitles")) == null ? '' : jade_interp)) + "</h3>");
  break;
case 'menuDivider':
buf.push("<div class=\"c-menu-divider\"></div>");
  break;
}}.call(this,"controlName" in locals_for_with?locals_for_with.controlName:typeof controlName!=="undefined"?controlName:undefined,"_t" in locals_for_with?locals_for_with._t:typeof _t!=="undefined"?_t:undefined,"label" in locals_for_with?locals_for_with.label:typeof label!=="undefined"?label:undefined));;return buf.join("");
};
    return function(locals) {
      if (locals) {
        if ("_t" in locals) { _t = locals._t.merge(_t); }
        // Jade helper objects must define this merge method.
      }
      return yudify(locals);
    };
  };
  if(typeof define === "function" && define.amd) {
    define([
      "js/vendor/jade"
      ,"i18n!bundles/videojs/layout/nls/controls"
    ], function(
      jade
      ,_t
    ) {
      var _h;
      return jadify(jade, _t, _h);
    });
  } else {
    wndw.jade.templates["bundles.videojs.layout.controls"] = jadify(wndw.jade.helpers);
  }
})(window);
